/**
 * Sprint API Documentation
 * Sprint API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: developer@sprintapp.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * ManagerCompensationTariff에 적용받는 ManagerRole
 */
export type UserRole = 'Admin' | 'SeniorManager' | 'JuniorManager' | 'PrepManager' | 'Expert' | 'PrepExpert' | 'ExpertManager' | 'PrepExpertManager' | 'SilverMember' | 'BronzeMember';

export const UserRole = {
    Admin: 'Admin' as UserRole,
    SeniorManager: 'SeniorManager' as UserRole,
    JuniorManager: 'JuniorManager' as UserRole,
    PrepManager: 'PrepManager' as UserRole,
    Expert: 'Expert' as UserRole,
    PrepExpert: 'PrepExpert' as UserRole,
    ExpertManager: 'ExpertManager' as UserRole,
    PrepExpertManager: 'PrepExpertManager' as UserRole,
    SilverMember: 'SilverMember' as UserRole,
    BronzeMember: 'BronzeMember' as UserRole
};

